import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Table, Spinner, ButtonGroup, ToggleButton, Row, Col} from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import ExcelInventory from './ExcelInventory';
import '../../appstyles/ClientsCSS/ClientsList.css';

function InventoryList() {
  const axiosInstance = useAxiosPrivate();
  const [inventory, setInventory] = useState({ data: [] });
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState(false);
  const [search] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const handleAvailabilityChange = (event) => {
  setAvailability(event.target.value === 'true');
  };

  const availabilityRadios = [
    { name: 'Disponibles', value: 'false' },
    { name: 'No disponibles', value: 'true' }
  ];

  const fetchInventory = (page, searchQuery, pageSize) => {
    setLoading(true)
    const url = searchQuery
      ? `api/logistics-inventory/?page=${page}&size=${pageSize}&inventory_status=Disponible&exclude=${availability}&product_name=${searchQuery}`
      : `api/logistics-inventory/?page=${page}&size=${pageSize}&inventory_status=Disponible&exclude=${availability}`;

    axiosInstance.get(url)
      .then(response => {
        setInventory(response.data);
        setTotalPages(response.data.totalPages); 
      })
      .catch(error => {
        alert('Error al cargar el inventario. Por favor, inténtelo de nuevo más tarde.');
      })
      .finally(() => {
        setLoading(false)
      });
  }

  useEffect(() => {
      fetchInventory(currentPage, search, rowsPerPage);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, search, availability, rowsPerPage]);

  /*const filteredProducts = useMemo(() => {
    if (!inventory || !Array.isArray(inventory.data)) {
      return [];
    }
    
    return inventory.data.filter(product => {
      return product.client_name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  });
  }, [inventory, search]);*/

  const handleRowClick = (inventoryId) => {
  navigate(`/inventory/details/${inventoryId}`);
  };

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
  };


  return (
    <div className='maestros-list'>
    <h2>Lista de Inventario</h2>
    <hr />
    <ButtonGroup toggle style={{width: '30%'}}>
    {availabilityRadios.map((radio, idx) => (
      <ToggleButton
        key={idx}
        id={`radio-${idx}`}
        type="radio"
        variant={idx % 2 ? 'outline-secondary' : 'outline-secondary'}
        name="radio"
        value={radio.value}
        checked={availability.toString() === radio.value}
        onChange={(e) => handleAvailabilityChange(e)}
    >
        {radio.name}
      </ToggleButton>
      ))}
    </ButtonGroup>
    {/*}
    <Form.Control
      style={{ width: '50%' }}
      type="search"
      placeholder="Buscar por nombre de cliente"            
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    >
    </Form.Control>
    */}

    {loading ? ( 
        <div className='loading-container'>
        <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
        <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
        </div>
    ) : (  
    <Table striped bordered hover responsive
      style={{overflowY: 'auto'}}
    >
        <thead>
            <tr>
                <th>ID</th>
                <th>Consecutivo</th>
                <th style={{ minWidth: '150px' }}>Producto</th>
                <th>Fabricante</th>
                <th>Proveedor</th>
                <th>Incoterm</th>
                <th>Stock</th>
                <th style={{ minWidth: '150px' }}>Disponibilidad</th>
                <th style={{ minWidth: '150px' }}>Estado de Trazabilidad</th>
            </tr>
        </thead>
        <tbody>
          {inventory.data.map( stock => (
            <tr key={stock.inventory_id} onClick={() => handleRowClick(stock.inventory_id)} style={{ cursor: 'pointer' }}>
              <td>{stock.inventory_id}</td>
              <td>{stock.parent_quote.consecutive}</td>
              <td>{stock.product.product_name}</td>
              <td>{stock.product.manufacturer}</td>
              <td>{stock.parent_quote.supplier_name}</td>
              <td>{stock.parent_quote.incoterm}</td>
              <td>{stock.stock} {stock.unit}</td>
              <td style={{ minWidth: '150px' }}>{stock.status}</td>
              <td style={{ minWidth: '150px' }}>{stock.tracking_status}</td>
            </tr>
            ))}
        </tbody>
    </Table>
    )}
    <Row style={{ alignItems: 'center', marginTop: '1.5rem' }}>
      <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
        <ExcelInventory />
      </Col>
      <Col md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <ListPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={value => {
            setRowsPerPage(value);
            setCurrentPage(1);
          }}
        />
      </Col>
    </Row>
    </div>
  )
}

export default InventoryList